import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import toast from 'react-hot-toast';
import { getLightweightStoresForBusiness } from 'api/admin/businesses/businesses';
import { ApiError } from 'types/api';

export interface GetLightweightStoresForBusinessOutput {
  success: boolean;
  stores: Array<{
    id: number;
    name: string;
  }>;
}

export type UseLightweightStoresInBusinessOutput =
  | GetLightweightStoresForBusinessOutput['stores']
  | null;

export const useLightweightStoresInBusiness = (businessId?: number, enabled?: boolean) => {
  return useQuery<unknown, ApiError, UseLightweightStoresInBusinessOutput>({
    queryKey: ['get-stores-in-business', businessId],
    queryFn: async () => {
      if (!businessId) {
        return null;
      }

      const { data } = (await getLightweightStoresForBusiness(
        businessId,
      )) as AxiosResponse<GetLightweightStoresForBusinessOutput>;
      return data.stores;
    },
    onError: (error) => {
      Sentry.captureException(error);
      toast.error(
        error?.response?.data?.error ?? 'An error occurred while fetching stores in business',
        {
          duration: 4000,
        },
      );
      return error;
    },
    enabled,
  });
};
